import React, {useLayoutEffect, useMemo, useRef, useState} from 'react';
import {Button, Checkbox} from "uikit";
import GearIcon from '@/assets/images/icons/12/gear.svg'
import TrashIcon from '@/assets/images/icons/12/trash.svg'
import styles from './Group.module.scss'
import table from '@/views/Admin/Events/Event/Promocodes/Table/Table.module.scss'
import {GroupPropsInterface} from "@/views/Admin/Events/Event/Promocodes/Group/Group.props.interface";
import EditIcon from "@/assets/images/icons/12/pencil.svg";
import Rename from "@/views/Admin/Events/Event/Promocodes/Rename/Rename";
import {PromocodeGroupsService} from "@/services/PromocodeGroupsService/PromocodeGroupsService";
import JSONAPI from "@/utils/JSONAPI/JSONAPI";
import {useLocation} from "react-router-dom";
import {useQueryRouter} from "@/hooks/useQueryRouter/useQueryRouter";

const Group = ({data, onChange, onRemove, onEdit, onActive}: GroupPropsInterface) => {
    const [active, setActive] = useState<boolean>(false);
    const renameRef = useRef<(payload: Record<string, string>) => void>(console.log)
    const {search} = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const {query, set} = useQueryRouter()
    const id = Number(params.get('id'));

    useLayoutEffect(() => {
        if (String(id) === String(data.id)) {
            onEdit(data)
        }
    }, [query?.id])

    const handleActive = () => {
        onActive(data)
    }

    const handleRemove = () => {
        onRemove([data])
    }

    const handleEdit = async () => {
        set({id: data.id})
    }

    const handleRename = () => {
        renameRef.current = async (payload) => {
            try {
                const schema = JSONAPI.inferSchemaFromSample(data);
                const body = JSONAPI.serialize('promocode-groups', payload, schema);
                return await PromocodeGroupsService.Update(data.id, body);
            } catch (e: any) {
                return e;
            }
        };
        setActive(true);
    };

    const handleSubmit = (payload: Record<string, string>) => {
        return renameRef.current?.(payload);
    };

    const handleCancel = () => {
        setActive(false);
    };

    return (
        <>
            <Rename
                data={data}
                onChange={onChange}
                onSubmit={active ? handleSubmit : undefined}
                onCancel={handleCancel}
            />
            <div className={[table.row, styles.container].filter(Boolean).join(' ')}>
                <div className={table.cell} data-label="Группа">
                    <div className={table.checkbox}>
                        <Checkbox
                            value={data.isActive as boolean}
                            onChange={handleActive}>
                            <p>
                                {data.name || '–'}
                            </p>
                        </Checkbox>
                        <Button
                            title={'Редактировать'}
                            type={'secondary'}
                            size={'xxsmall'}
                            theme={'ghost'}
                            onClick={handleRename}
                            className={[styles.button, styles.copy].filter(Boolean).join(' ')}>
                            <EditIcon/>
                        </Button>
                    </div>
                </div>

                <div className={table.cell} data-label="Событие">
                    <p>{data.event?.eventTitle || '–'}</p>
                </div>
                <div className={table.cell} data-label="Количество">
                    <p>
                        {Number(data.promocodesCount) || '–'}
                    </p>
                </div>
                <div className={table.cell}>
                    <div className={styles.action}>
                        <div className={styles.select}>
                            <Button
                                type={'secondary'}
                                theme={'ghost'}
                                className={styles.button}
                                disabled={!Boolean(data.promocodesCount)}
                                onClick={handleEdit}>
                                <GearIcon/>
                            </Button>
                        </div>
                        <div className={styles.select}>
                            <Button
                                type={'tertiary'}
                                theme={'ghost'}
                                className={styles.button}
                                onClick={handleRemove}>
                                <TrashIcon/>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Group;
